import { cloneDeep } from 'lodash'

export class FieldsSerializer {
	private static arrayFieldsToString = (obj: any): any => {
		if (typeof obj !== 'object') return obj
		const result = cloneDeep(obj)
		const keys = Object.keys(result)
		keys.forEach((key: string): void => {
			if (Array.isArray(result[key])) {
				result[key] = result[key].join(',')
			}
		})
		return result
	}

	public static clearEmptyFields = (obj: any): any => {
		const result = cloneDeep(obj)
		const keys = Object.keys(result)
		keys.forEach((key): void => {
			if (Array.isArray(result[key]) && !result[key].length) {
				delete result[key]
			}
			if (
				!Array.isArray(result[key]) &&
				(typeof result[key] === 'undefined' || result[key] === null || !result[key])
			) {
				delete result[key]
			}
			if (!Array.isArray(result[key]) && typeof result[key] === 'string' && !result[key].length) {
				delete result[key]
			}
		})
		return result
	}

	public static clearUndefinedFields = (obj: any): any => {
		const result = cloneDeep(obj)
		Object.keys(result).forEach((key): void => {
			if (typeof result[key] === 'undefined') delete result[key]
		})
		return result
	}

	public static serializeFields = (obj: any): any => FieldsSerializer.arrayFieldsToString(obj)

	public static checkboxesToArray = (obj: { i: boolean }): string[] => {
		// {'235': undefinded, '236': true, '237': true} -> '236, 237'
		if (typeof obj !== 'object') return obj
		return Object.entries(obj).reduce((acc, [key, value]) => (value ? [...acc, +key] : acc), [])
	}
}
